import React from 'react';
import { 
  Box, 
  Button, 
  Container, 
  Typography, 
  useTheme
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import NatureIcon from '@mui/icons-material/Nature';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const TermsOfServicePage: React.FC = () => {
  const navigate = useNavigate();
  const theme = useTheme();

  const handleBack = () => {
    navigate(-1);
  };

  const handleHome = () => {
    navigate('/');
  };

  const handlePrivacyPolicy = () => {
    navigate('/privacy-policy');
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: `linear-gradient(135deg, ${theme.palette.background.default} 0%, ${theme.palette.grey[900]} 100%)`,
        py: 4
      }}
    >
      <Container maxWidth="lg" sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
        {/* Header */}
        <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={2} sx={{ mb: 4 }}>
          <Box display="flex" alignItems="center" gap={2}>
            <NatureIcon sx={{ fontSize: 32, color: theme.palette.primary.main }} />
            <Typography variant="h5" component="h1" fontWeight="bold">
              SavaQuan
            </Typography>
          </Box>
          <Box display="flex" flexWrap="wrap" gap={2}>
            <Button 
              variant="outlined" 
              startIcon={<ArrowBackIcon />}
              onClick={handleBack}
            >
              Back
            </Button>
            <Button 
              variant="outlined" 
              onClick={handlePrivacyPolicy}
            >
              Privacy Policy
            </Button>
            <Button 
              variant="contained" 
              onClick={handleHome}
            >
              Home
            </Button>
          </Box>
        </Box>

        {/* Terms of Service iframe */}
        <Box 
          sx={{ 
            flex: 1, 
            borderRadius: 2, 
            overflow: 'hidden',
            boxShadow: theme.shadows[8]
          }}
        >
          <iframe
            src="/documents/terms-of-service.html"
            title="Terms of Service"
            style={{
              width: '100%',
              height: '100%',
              border: 'none',
              borderRadius: '8px'
            }}
          />
        </Box>
      </Container>
    </Box>
  );
};

export default TermsOfServicePage; 